import { GoogleMapMarker } from '../../Api/Models/GoogleMap';
import './googleMapsTypes'; /* global google */

export default class MapHelper {
    readonly gmMap: google.maps.Map;

    constructor(mapElement: HTMLElement, gmOptions: google.maps.MapOptions) {
        this.gmMap = new google.maps.Map(mapElement, gmOptions);
    }

    addMarker(marker: GoogleMapMarker) {
        const gmMarker = new google.maps.Marker({ map: this.gmMap, position: marker, animation: marker.animation });
        let { content } = marker;

        if (marker.image) {
            content = `<div class="marker-image"><img src="${marker.image}"></div>${content ?? ''}`;
        }

        if (content) {
            const gmWindow = new google.maps.InfoWindow({ content });
            const gmWindowOpen = () =>
                /* @ts-ignore - undocumented function getMap - map is null if window is closed */
                gmWindow.getMap() ? gmWindow.close() : gmWindow.open({ map: this.gmMap, anchor: gmMarker });

            if (marker.open) {
                gmWindowOpen();
            }

            gmMarker.addListener('click', gmWindowOpen);
        }
    }
}
